import initFAQ from "../components/FAQ/FAQ.js";
import initPopup from "../components/Popup/Popup.js";
import EmblaCarousel from "embla-carousel";

document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM is fully loaded and parsed!");
  mobileMenu();
  initFAQ();
  globalSliders();
  initPopup();
});

function globalSliders() {
  const sliders = document.querySelectorAll(".global-sliders");
  const options = { loop: true, align: "start" };

  sliders.forEach((slider) => {
    const emblaApi = EmblaCarousel(slider, options);

    // --- autoplay ---
    let autoplay = setInterval(() => emblaApi.scrollNext(), 10000);
    slider.addEventListener("mouseenter", () => clearInterval(autoplay));
    slider.addEventListener("mouseleave", () => {
      autoplay = setInterval(() => emblaApi.scrollNext(), 10000);
    });

    // --- arrows ---
    const prevBtn = slider.querySelector(".prev");
    const nextBtn = slider.querySelector(".next");
    if (prevBtn && nextBtn) {
      prevBtn.addEventListener("click", () => emblaApi.scrollPrev());
      nextBtn.addEventListener("click", () => emblaApi.scrollNext());
    }

    // --- dots ---
    const dotsContainer = slider.querySelector(".global-sliders-dots");
    if (dotsContainer) {
      const dots = emblaApi.scrollSnapList().map((_, i) => {
        const dot = document.createElement("span");
        dot.classList.add("global-sliders-dot");
        dot.addEventListener("click", () => emblaApi.scrollTo(i));
        dotsContainer.appendChild(dot);
        return dot;
      });

      const updateDots = () => {
        const selected = emblaApi.selectedScrollSnap();
        dots.forEach((dot, i) =>
          dot.classList.toggle("is-selected", i === selected),
        );
      };

      emblaApi.on("select", updateDots);
      emblaApi.on("init", updateDots);
      updateDots();
    }
  });
}

function mobileMenu() {
  const mobileMenu = document.querySelector(".main-nav");
  const mobileMenuBtn = document.querySelector(".mobile-menu-btn");
  const mobileMenuCloseBtn = document.querySelector(".mobile-menu-close-btn");

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener("click", () => {
      mobileMenu.classList.add("nav-show");
    });
  }

  if (mobileMenuCloseBtn) {
    mobileMenuCloseBtn.addEventListener("click", () => {
      mobileMenu.classList.remove("nav-show");
    });
  }

  document.addEventListener("click", (e) => {
    const clickedInsideMenu = mobileMenu.contains(e.target);
    const clickedButton = mobileMenuBtn.contains(e.target);

    if (!clickedInsideMenu && !clickedButton) {
      mobileMenu.classList.remove("nav-show");
    }
  });
}
